import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("kk_lang") || "de");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("kk_lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.classList.toggle("font-tamil", lang === "ta");
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang] || translations.de;
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else return path;
    }
    return cur;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
